import React, { useState, useEffect } from 'react'
import { Card, Container, Row, Col, Form, Button } from 'react-bootstrap'
import { useHistory } from 'react-router'
import { GenerateRandomNumber, uploadRecipe } from '../../../../firebase/firebase'
export const AddRecipeForm = () => {
    const history = useHistory()
    const [recipe, setRecipe] = useState({
        title: "",
        description: '',
        owner: '',
        id: ''

    })

    const onChange = (e) => {
        setRecipe({ ...recipe, [e.target.name]: e.target.value })

    }

    const handleCancel = (e) => {
        history.push('/recipes')
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            let recipeToUpload = { ...recipe }
            recipeToUpload.id = GenerateRandomNumber()
            await uploadRecipe(recipeToUpload).then((recipe) => {
                history.push(`/recipes/view/${recipe.id}`)
            })


        }

        catch (e) {
            alert(`Error " ${e.message}`)
        }
    }
    return (
        <Container className='py-3'>
            <Row className="justify-content-md-center">
                <Col lg={8}>
                    <Card>
                        <Card.Header>
                            Add a recipe
                        </Card.Header>
                        <Card.Body>
                            <Form onSubmit={handleSubmit}>

                                <Row className="mb-3">
                                    <Form.Control

                                        onChange={onChange}
                                        type="text"
                                        placeholder="Title"
                                        value={recipe.title}
                                        name='title'
                                    />



                                </Row>
                                <Row className="mb-3">
                                    <Form.Control

                                        onChange={onChange}
                                        type="text"
                                        placeholder="Description"
                                        value={recipe.description}
                                        name='description'
                                    />

                                </Row>
                                <Row xs={6}>
                                    <Col>
                                        <Button disabled={recipe.title === '' || recipe.description === ''} type="submit">Create</Button>
                                    </Col>
                                    <Col>
                                        <Button type='button' variant="secondary" onClick={handleCancel}>
                                            Cancel
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

        </Container>
    )
}